import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';
import { UIText2 } from '@cian/ui-kit';

import { RangeInput } from 'shared/components/RangeInput';
import { FC, ReactNode } from 'react';
import styles from './DropdownPrice.css';

interface IDropdownPriceProps {
  valueMin: number | null;
  valueMax: number | null;
  priceTypeFilter: ReactNode;
  showCorrectionHint?: boolean;

  onChangeMin: (value: number | null) => void;
  onChangeMax: (value: number | null) => void;
}

export const DropdownPrice: FC<IDropdownPriceProps> = ({
  valueMax,
  valueMin,
  priceTypeFilter,
  showCorrectionHint = false,
  onChangeMax,
  onChangeMin,
}) => {
  return (
    <div className={styles['dropdown']} data-testid="DropdownPrice">
      <div className={styles['dropdown-filter']}>
        <RangeInput
          min={0}
          max={999999999999}
          joined={false}
          postfix={'\u20bd'}
          valueMin={valueMin}
          valueMax={valueMax}
          isForceUpdate
          allowMaxBelowMin
          onChangeMin={onChangeMin}
          onChangeMax={onChangeMax}
        />
      </div>
      {showCorrectionHint && (
        <div className={styles['correction-hint']} data-testid="PriceCorrectionHint">
          <IconFunctionalInformationCircle16 color="primary_100" />
          <UIText2 color="text-primary-default">Округляем цену, чтобы вы видели больше вариантов</UIText2>
        </div>
      )}
      <div className={styles['dropdown-filter']} data-testid="DropdownPriceType">
        {priceTypeFilter}
      </div>
    </div>
  );
};
